import { IconButton, Tooltip } from '@chakra-ui/react';
import { useState } from 'react';
import { downloadFile } from '../../../canopy-ui-components/api/download';
import ActDl from '../../../canopy-ui-components/components/Icons/ActDl';
import * as ga from '../../../canopy-ui-components/google-analytics/index';
import { useCurrentColors } from '../../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';

interface IProps extends PageComponentProps<any> {
    data: Record<string, any>;
    userId: string | number;
}
function DownloadStrategyAction({ data, globalProps: { t }, userId }: any) {
    const currentColors = useCurrentColors();
    const [isLoading, setIsLoading] = useState(false);
    const handleDownload = async () => {
        const name = data?.[0]?.name;
        setIsLoading(true);
        ga.event({
            action: `${window.location.pathname.replace(
                '//g/',
                ''
            )} > Clicked Download Strategy`,
            strategyType: name,
        });
        await downloadFile({
            url: `strategies?output_format=download_hash&types=${escape(
                JSON.stringify([name])
            )}&parent_user_ids=${userId}`,
            fetchKey: true,
        });
        setIsLoading(false);
    };
    return (
        <Tooltip
            aria-label="download"
            label={t('ui.mm.tooltip.download')}
            placement="bottom-start"
            hasArrow>
            <IconButton
                background="transparent"
                cursor="pointer"
                border="none"
                width="20px !important"
                minWidth="20px !important"
                height="20px !important"
                icon={<ActDl />}
                aria-label="download"
                data-test="download"
                backgroundColor="transparent"
                color={currentColors.brand['300']}
                variant="ghost"
                _hover={{
                    backgroundColor: 'transparent',
                }}
                _focus={{
                    border: '0px',
                    outline: 'none',
                }}
                _active={{
                    border: '0px',
                }}
                isLoading={isLoading}
                onClick={handleDownload}></IconButton>
        </Tooltip>
    );
}

export default DownloadStrategyAction;
